var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUserAdd = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.667 5.333a2.666 2.666 0 0 0-5.334 0 2.666 2.666 0 1 0 5.334 0zM10 6.667V8h2v2h1.333V8h2V6.667h-2v-2H12v2h-2zM.667 12v1.333h10.666V12c0-1.773-3.553-2.667-5.333-2.667-1.78 0-5.333.894-5.333 2.667z"
})));
export default SvgUserAdd;